/*
  Tomassi (velocità): lista paesi del selettore caricata su richiesta.
  Lo snippet country-localization rende solo il paese corrente; qui scarichiamo
  sections/tomassi-countries.liquid (Section Rendering API) la prima volta che il
  cliente si avvicina a un selettore, e lo riusiamo per tutti i selettori della pagina.
  localization-form.js (Craft) cerca gli <a> a ogni filtro/tasto, quindi funziona
  sui nuovi elementi; il clic sul paese lo gestiamo qui perché Craft lo aggancia
  solo agli elementi presenti all'avvio.
*/
(function () {
  if (window.__tcCountries) return;
  window.__tcCountries = true;

  var request = null;

  function url() {
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    return root + '?section_id=tomassi-countries';
  }

  function load() {
    if (request) return request;
    request = fetch(url(), { credentials: 'same-origin' })
      .then(function (res) {
        if (!res.ok) throw new Error(res.status);
        return res.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var wrap = doc.querySelector('.shopify-section') || doc.body;
        if (!wrap.querySelector('ul.countries a')) throw new Error('empty');
        fill(wrap.innerHTML);
      })
      .catch(function () {
        request = null; // riprova al prossimo passaggio
      });
    return request;
  }

  function fill(markup) {
    document.querySelectorAll('[data-tc-countries]:not([data-tc-loaded])').forEach(function (list) {
      var form = list.closest('localization-form');
      list.innerHTML = markup;
      list.setAttribute('data-tc-loaded', '');
      if (!form) return;
      list.querySelectorAll('a').forEach(function (a) {
        a.addEventListener('click', function (event) {
          event.preventDefault();
          var input = form.querySelector('input[name="country_code"]');
          var f = form.querySelector('form');
          if (!input || !f) return;
          input.value = a.dataset.value;
          f.submit();
        });
      });
      // se il cliente ha già scritto nel filtro, riapplicalo sulla lista completa
      var search = form.querySelector('input[name="country_filter"]');
      if (search && search.value) search.dispatchEvent(new KeyboardEvent('keyup'));
    });
  }

  function maybeLoad(event) {
    var t = event.target;
    if (!t || !t.closest) return;
    var form = t.closest('localization-form');
    if (form && form.querySelector('[data-tc-countries]:not([data-tc-loaded])')) load();
  }

  ['pointerover', 'focusin', 'touchstart', 'click'].forEach(function (type) {
    document.addEventListener(type, maybeLoad, { capture: true, passive: true });
  });
})();
